import React from "react";
import PropTypes from "prop-types";
import Svg, { Path, Circle } from "react-native-svg";
import { StyleSheet, Dimensions, View } from "react-native";
import { StyleContext } from "app/contexts/Style";

export default class LogoSVG extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    title: PropTypes.bool,
  };

  static defaultProps = {
    size: 26,
    // color: colorVars.green,
    title: false,
  };

  render() {
    let exaggerated = true;
    // exaggerated = false;
    let { size, width, height, color, wrapperStyle } = this.props;
    if (!color) color = this.context.colors.foreground;
    if (!width) width = size;
    // if (!height) height = size * 0.4125;
    if (!height) height = size;

    if (exaggerated)
      return (
        <View
          style={[
            wrapperStyle || null,
            // { borderWidth: 1, borderColor: "red" }
          ]}
        >
          <Svg height={height} width={width} viewBox="0 0 650 650">
            <Circle
              cx="327"
              cy="258"
              r="179.5"
              fill={"transparent"}
              stroke={color}
              strokeWidth={35}
            />
            <Circle cx="558" cy="122" r="50" fill={color} />
            <Circle cx="329" cy="525" r="50" fill={color} />
            <Circle cx="95" cy="125" r="50" fill={color} />
            <Circle cx="394" cy="486" r="12" fill={color} />
            <Circle cx="328" cy="602" r="12" fill={color} />
            <Circle cx="261" cy="487" r="12" fill={color} />
            <Circle cx="558" cy="199" r="12" fill={color} />
            <Circle cx="491" cy="84" r="12" fill={color} />
            <Circle cx="28" cy="87" r="12" fill={color} />
            <Circle cx="95" cy="202" r="12" fill={color} />
            <Circle cx="162" cy="87" r="12" fill={color} />
            <Circle cx="625" cy="84" r="12" fill={color} />
          </Svg>
        </View>
      );

    return (
      <View
        style={[
          wrapperStyle || null,
          // { borderWidth: 1, borderColor: "red" }
        ]}
      >
        <Svg height={height} width={width} viewBox="0 0 1024 1024">
          <Path
            d="M524.763 910.078C540.86 900.795 546.361 880.203 537.043 864.082C527.725 847.961 507.119 842.423 491.021 851.706C474.923 860.99 469.423 881.582 478.74 897.702C488.059 913.824 508.665 919.362 524.763 910.078Z"
            fill={color}
          />
          <Path
            d="M642.797 651.257C626.885 642.06 606.527 647.532 597.327 663.485C588.126 679.439 593.573 699.828 609.486 709.025C625.398 718.223 645.756 712.751 654.956 696.798C664.157 680.844 658.71 660.455 642.797 651.257Z"
            fill={color}
          />
          <Path
            d="M357.739 680.953C357.73 699.252 372.583 714.082 390.918 714.073C409.255 714.064 424.123 699.218 424.132 680.918C424.141 662.619 409.289 647.789 390.953 647.798C372.617 647.807 357.748 662.653 357.739 680.953Z"
            fill={color}
          />
          <Path
            d="M541.844 806.501C573.99 787.963 585.004 746.823 566.369 714.584C547.728 682.335 506.525 671.285 474.368 689.829C442.221 708.367 431.208 749.507 449.843 781.745C468.484 813.995 509.687 825.045 541.844 806.501Z"
            fill={color}
          />
          <Path
            d="M914.14 197.157C897.721 187.667 876.717 193.315 867.226 209.771C857.736 226.228 863.352 247.262 879.771 256.753C896.19 266.243 917.194 260.595 926.685 244.139C936.175 227.682 930.558 206.648 914.14 197.157Z"
            fill={color}
          />
          <Path
            d="M629.576 225.039C629.566 244.03 644.981 259.418 664.005 259.409C683.03 259.399 698.459 243.996 698.469 225.005C698.478 206.014 683.063 190.626 664.039 190.635C645.015 190.644 629.585 206.047 629.576 225.039Z"
            fill={color}
          />
          <Path
            d="M798.23 453.711C814.545 444.302 820.117 423.434 810.676 407.1C801.235 390.767 780.356 385.153 764.041 394.561C747.726 403.97 742.154 424.838 751.595 441.172C761.036 457.505 781.915 463.119 798.23 453.711Z"
            fill={color}
          />
          <Path
            d="M814.344 233.248C782.217 214.678 741.082 225.709 722.48 257.967C703.872 290.236 714.904 331.443 747.042 350.02C779.169 368.591 820.304 357.559 838.906 325.301C857.514 293.033 846.483 251.825 814.344 233.248Z"
            fill={color}
          />
          <Path
            d="M89.9772 217.725C89.9683 235.837 104.669 250.515 122.817 250.506C140.966 250.497 155.682 235.803 155.691 217.69C155.7 199.579 141 184.901 122.852 184.91C104.703 184.919 89.9861 199.613 89.9772 217.725Z"
            fill={color}
          />
          <Path
            d="M261.841 459.356C277.763 450.174 283.203 429.807 273.987 413.863C264.771 397.917 244.39 392.44 228.468 401.622C212.546 410.804 207.106 431.171 216.322 447.115C225.538 463.061 245.919 468.538 261.841 459.356Z"
            fill={color}
          />
          <Path
            d="M384.945 189.246C369.013 180.037 348.629 185.516 339.417 201.489C330.205 217.464 335.658 237.878 351.591 247.088C367.523 256.297 387.908 250.818 397.119 234.845C406.332 218.87 400.878 198.456 384.945 189.246Z"
            fill={color}
          />
          <Path
            d="M177.864 288.743C177.845 325.851 207.966 355.959 245.203 355.94C282.453 355.921 312.624 325.763 312.643 288.642C312.662 251.534 282.54 221.426 245.303 221.445C208.054 221.464 177.883 251.622 177.864 288.743Z"
            fill={color}
          />
          <Circle
            r="169.348"
            transform="matrix(1 0 0 -1 510.893 443.629)"
            fill={color}
          />
        </Svg>
      </View>
    );
  }
}
